import React from 'react'
import { StyledIcon } from '../StyledIcon'

// eslint-disable-next-line import/prefer-default-export
export const CouponValid = ({ icon, size, customProps }) => (
  <StyledIcon
    viewBox="0 0 24 24"
    a11yTitle={icon}
    color="plain"
    size={size}
    {...customProps}
  >
    <g clipPath="url(#clip0_578_51736)">
      <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" fill="#669944"/>
    </g>
    <defs>
      <clipPath id="clip0_578_51736">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </StyledIcon>
)
